module.exports = __webpack_public_path__ + "media/residential.99c874cb.svg";